import React from "react";
import { View, Text } from "@react-pdf/renderer";

import { styles } from "./pdfStyles";

// Small reusable building blocks shared by all three F280 PDF pages.
// These mirror the legacy CSS class combinations (`.row`, `.cell`,
// `.smallTitle`, `.selectionBox*`, `.smallNumberFields`, ...) as react-pdf
// primitives so each page reads like the original markup.

export const Row = ({ noBorder, style, children }) => (
    <View style={[styles.row, noBorder && styles.noBorderBottom, style]}>{children}</View>
);

// Set to true to bring back the CSA form's small field-number tags (1..76)
// and checkbox letters (g, h) — hidden for now per product request.
const SHOW_FIELD_NUMS = false;

// Absolutely-positioned field number tag (legacy `.smallNumberFields`).
export const NumField = ({ children, style }) =>
    SHOW_FIELD_NUMS ? <Text style={[styles.numField, style]}>{children}</Text> : null;

// Grey section header bar (legacy `.smallTitle`).
export const SmallTitle = ({ children, flat, supText, style }) => (
    <View style={[styles.smallTitle, flat && styles.smallTitleFlat, style]}>
        <Text style={styles.smallTitleH2}>{children}</Text>
        {supText ? (
            <View style={styles.titleSupWrap}>
                <Text style={styles.titleSupText}>{supText}</Text>
            </View>
        ) : null}
    </View>
);

// Label + blue value pair (legacy `.cellTextContainer` with span + p).
export const Field = ({ label, value, num, labelStyle, valueStyle, containerStyle, autoLabel }) => (
    <View style={[styles.fieldCell, containerStyle]}>
        <View style={styles.fieldContainer}>
            <Text style={[autoLabel ? styles.fieldLabelAuto : styles.fieldLabel, labelStyle]}>{label}</Text>
            <Text style={[styles.fieldValue, valueStyle]}>{value || ""}</Text>
        </View>
        {num != null ? <NumField>{num}</NumField> : null}
    </View>
);

// A single checkbox + label (legacy `.selectionBoxWrapper`). An optional field
// number renders inline as a small subscript right after the label so it stays
// beside the text (an absolute tag drifts to the cell floor when the row is short).
export const Checkbox = ({ checked, label, wrapperStyle, num }) => (
    <View style={[styles.selectionBoxWrapper, wrapperStyle]}>
        <View style={styles.checkbox}>
            <Text style={styles.checkboxX}>{checked ? "X" : ""}</Text>
        </View>
        <Text style={styles.boxText}>{label}</Text>
        {num != null && SHOW_FIELD_NUMS ? <Text style={styles.boxNum}>{num}</Text> : null}
    </View>
);

// A value inside a bordered rectangle (legacy `.rectangle`).
export const ValueBox = ({ value, unit, rectStyle }) => (
    <View style={styles.boxWithTextWrapper}>
        <View style={[styles.rectangle, rectStyle]}>
            <Text style={styles.heatText}>{value}</Text>
        </View>
        <Text style={styles.smallLabel}>{unit}</Text>
    </View>
);

// A numbered clause paragraph (legacy `.textRowWithNumber`).
export const Clause = ({ num, children, style }) => (
    <View style={[styles.textRowWithNumber, style]}>
        <Text style={styles.clauseNum}>{num}</Text>
        <Text style={styles.clauseText}>{children}</Text>
    </View>
);
